module.exports = __webpack_public_path__ + "media/img/frontend_application/myhosting/scheduled-d209e4c1437323e9dbe2f8b965703e71.png";